/* VITALIA PARIS — Ambiance « Nuit & fumée » (06/10/2026)
   1) Fumée WebGL descendante sur les canvas [data-vp-smoke-gl] : démarrage après chargement, demi-résolution, 30 i/s max,
      pause hors écran et onglet caché, image fixe si l'utilisateur réduit les animations, rien si WebGL absent.
   2) Apparition douce au défilement (opacité + translation, sans décalage de mise en page) des blocs situés sous la ligne de flottaison. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Fumée ---------- */
  var VS = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';
  var FS = [
    'precision mediump float;',
    'uniform vec2 r;uniform float t;uniform vec2 m;uniform float k;',
    'float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
    'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);',
    ' return mix(mix(h(i),h(i+vec2(1.,0.)),f.x),mix(h(i+vec2(0.,1.)),h(i+vec2(1.,1.)),f.x),f.y);}',
    'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*n(p);p=p*2.03+vec2(1.7,9.2);a*=.5;}return v;}',
    'void main(){',
    ' vec2 uv=gl_FragCoord.xy/r;',
    ' vec2 p=uv*vec2(r.x/r.y,1.)*2.1;',
    ' float s=t*.045;',
    ' vec2 q=vec2(fbm(p+vec2(0.,s)),fbm(p+vec2(5.2,1.3+s)));',
    ' vec2 d=m-uv;d.x*=r.x/r.y;float md=exp(-dot(d,d)*14.);',
    ' vec2 w=p+2.4*q+vec2(sin(s*.7)*.3,s*1.5)+d*md*1.4;',
    ' float f=fbm(w);',
    ' float sm=smoothstep(.48,.98,f)*(.55+.45*fbm(w*1.8+vec2(0.,s*2.2)));',
    ' float a=sm*k*(.55+.45*uv.y)+md*.035;',
    ' gl_FragColor=vec4(vec3(.95,.91,.84)*a,a);',
    '}'
  ].join('\n');

  function smoke(cv) {
    var gl = cv.getContext('webgl', { alpha: true, antialias: false, depth: false, stencil: false, premultipliedAlpha: true, powerPreference: 'low-power', failIfMajorPerformanceCaveat: true });
    if (!gl) return;
    /* Rendu logiciel (pas de carte graphique) : on garde la fumée CSS, bien plus légère. */
    try {
      var dbg = gl.getExtension('WEBGL_debug_renderer_info');
      var ren = String(dbg ? gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL) : gl.getParameter(gl.RENDERER));
      if (/swiftshader|llvmpipe|software|softpipe|basic render/i.test(ren)) return;
    } catch (e) { /* on continue */ }
    function sh(type, src) { var o = gl.createShader(type); gl.shaderSource(o, src); gl.compileShader(o); return gl.getShaderParameter(o, gl.COMPILE_STATUS) ? o : null; }
    var v = sh(gl.VERTEX_SHADER, VS), f = sh(gl.FRAGMENT_SHADER, FS);
    if (!v || !f) return;
    var pr = gl.createProgram(); gl.attachShader(pr, v); gl.attachShader(pr, f); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return;
    gl.useProgram(pr);
    var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var al = gl.getAttribLocation(pr, 'a'); gl.enableVertexAttribArray(al); gl.vertexAttribPointer(al, 2, gl.FLOAT, false, 0, 0);
    var uR = gl.getUniformLocation(pr, 'r'), uT = gl.getUniformLocation(pr, 't'), uM = gl.getUniformLocation(pr, 'm'), uK = gl.getUniformLocation(pr, 'k');
    var host = cv.parentNode, mx = .62, my = .45, tx = mx, ty = my, run = false, vis = true, raf = 0, last = 0, t0 = performance.now() - 18000;
    gl.uniform1f(uK, parseFloat(cv.getAttribute('data-intensity')) || .34);

    function size() {
      var w = cv.clientWidth, h = cv.clientHeight; if (!w || !h) return;
      var sc = Math.min(.5, 960 / w);
      cv.width = Math.max(1, Math.round(w * sc)); cv.height = Math.max(1, Math.round(h * sc));
      gl.viewport(0, 0, cv.width, cv.height); gl.uniform2f(uR, cv.width, cv.height);
    }
    function draw(now) {
      mx += (tx - mx) * .05; my += (ty - my) * .05;
      gl.uniform1f(uT, (now - t0) / 1000); gl.uniform2f(uM, mx, my);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
    /* Garde-fou : si l'appareil peine (moins de ~20 images/s), la fumée WebGL s'arrête et la fumée CSS reprend. */
    var frames = 0, slow = 0, prev = 0;
    function loop(now) {
      raf = 0; if (!run) return;
      if (prev && frames < 90) { if (now - prev > 50) slow++; frames++; if (frames >= 30 && slow / frames > .4) { run = false; cv.classList.remove('is-on'); return; } }
      prev = now;
      if (now - last > 32) { last = now; draw(now); }
      raf = requestAnimationFrame(loop);
    }
    function sync() {
      var go = vis && !document.hidden && !reduce;
      if (go && !run) { run = true; raf = requestAnimationFrame(loop); }
      else if (!go && run) { run = false; prev = 0; if (raf) cancelAnimationFrame(raf); raf = 0; }
    }
    size(); draw(performance.now()); cv.classList.add('is-on');
    if (reduce) return;
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { size(); draw(performance.now()); }, 150); }, { passive: true });
    function point(e) { var r = cv.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width; ty = 1 - (e.clientY - r.top) / r.height; }
    host.addEventListener('pointermove', point, { passive: true });
    host.addEventListener('pointerdown', point, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; sync(); }).observe(cv);
    document.addEventListener('visibilitychange', sync);
    cv.addEventListener('webglcontextlost', function (e) { e.preventDefault(); run = false; cv.classList.remove('is-on'); });
    sync();
  }

  function startSmoke() {
    var list = document.querySelectorAll('canvas[data-vp-smoke-gl]');
    for (var i = 0; i < list.length; i++) { try { smoke(list[i]); } catch (e) { /* décor seulement */ } }
  }
  function later(fn) {
    var go = function () { ('requestIdleCallback' in window) ? requestIdleCallback(fn, { timeout: 1200 }) : setTimeout(fn, 300); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }
  if (document.querySelector('canvas[data-vp-smoke-gl]')) later(startSmoke);

  /* ---------- 2. Apparition au défilement ---------- */
  if (reduce || !('IntersectionObserver' in window)) return;
  var SEL = '[data-reveal],.vp-grammaire__header,.vp-grammaire__card,.vp-manifeste__media,.vp-manifeste__copy,.vp-featured__header,.product-card,.vp-journal-preview__header,.vp-journal-preview__card,.vp-newsletter > *,.vp-collection-guide > *,.vpn-band .vpn-wrap > *';
  var els = document.querySelectorAll(SEL), fold = window.innerHeight * .92, io;
  io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  for (var j = 0; j < els.length; j++) {
    var el = els[j];
    if (el.getBoundingClientRect().top < fold) continue;
    var sib = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
    el.style.setProperty('--rv-d', (Math.min(sib, 6) * 70) + 'ms');
    el.classList.add('vp-rv');
    io.observe(el);
  }
}());
